import {
    Box,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    Tooltip,
} from "@mui/material";
import { DoubleArrow, Search } from "@mui/icons-material";
import React from "react";
import { ControlledCliProps } from "./types";
import DatasourceSelector from "#components/DatasourceSelector";

export const ControlledCommandLine: React.FC<ControlledCliProps> = ({
    value,
    onSubmit,
    onChange,
    error,
    fullWidth = true,
}) => {
    const keyUp = (
        e: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => {
        if (e.key === "Enter") {
            e.preventDefault();
            onSubmit(value);
        }
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                {/*<Box>*/}
                <Input
                    fullWidth={fullWidth}
                    autoFocus
                    value={value}
                    placeholder="Type a query"
                    onChange={evt => onChange(evt.target.value)}
                    onKeyUp={e => keyUp(e)}
                    startAdornment={
                        <InputAdornment position="start">
                            <DoubleArrow />
                        </InputAdornment>
                    }
                    endAdornment={
                        <InputAdornment position="end">
                            <DatasourceSelector />
                            <Tooltip title="Start Search">
                                <IconButton onClick={() => onSubmit(value)}>
                                    <Search />
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>
                    }
                    inputProps={{
                        shrink: "true",
                    }}
                    error={error}
                />
                {/*</Box>*/}
            </Grid>
        </Grid>
    );
};
